import { createContext, useContext, useMemo, useState } from 'react';

const STORAGE_KEY = 'nafola.theme';

function readNight(): boolean {
  if (typeof document !== 'undefined' && document.documentElement.classList.contains('dark')) return true;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'night') return true;
    if (stored === 'day') return false;
  } catch {
    // stockage indisponible
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

interface ThemeValue {
  night: boolean;
  toggle: () => void;
}

const ThemeContext = createContext<ThemeValue | null>(null);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [night, setNight] = useState(readNight);

  const value = useMemo<ThemeValue>(
    () => ({
      night,
      toggle: () => {
        setNight((current) => {
          const next = !current;
          document.documentElement.classList.toggle('dark', next);
          localStorage.setItem(STORAGE_KEY, next ? 'night' : 'day');
          return next;
        });
      }
    }),
    [night]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const value = useContext(ThemeContext);
  if (!value) throw new Error('Thème indisponible');
  return value;
}
